import Image from 'components/Basic/Image/Image';
import useTranslation from 'next-translate/useTranslation';
import twMerge from 'utils/twMerge';

type WarningBarProps = {
    className?: string;
};

export const WarningBar: FC<WarningBarProps> = ({ children, className }) => {
    const { t } = useTranslation();

    return (
        <div className={twMerge('flex w-full items-center gap-2 bg-[#ffe5c7] px-5 py-4 text-small', className)}>
            <Image alt={t('Warning icon')} height={18} src="/icons/exclamation-mark-warning.png" width={18} />
            {children}
        </div>
    );
};
